import jsPDF from "jspdf";
import "jspdf-autotable";
import copy from "copy-to-clipboard";
import es from "../translate/es.json";
import en from "../translate/en.json";
import pt from "../translate/pt.json";
import XLSX from "xlsx";
import { cashStatusConfig } from "../config/constants";
import { exportToPDF, exportToExcel, exportMultipleTablesToExcel, exportMultipleTablesToPDF } from "../config/exports";
//  ------- > GETTERS
export const getUser = () => {
  const userStr = sessionStorage.getItem("user");
  if (userStr) return JSON.parse(userStr);
  else return null;
};

export const getToken = () => {
  return sessionStorage.getItem("token") || null;
};

export const getFirebaseToken = () => {
  return sessionStorage.getItem("firebaseToken") || null;
};

export const getClientDomain = (version) => {
  let domainV1 = "";
  let domainV2 = "";

  if (version === 2) return sessionStorage.getItem("apDomainV2") || domainV2;

  return sessionStorage.getItem("apDomain") || domainV1;
};

export const getClDomain = () => {
  return sessionStorage.getItem("clDomain") || null;
};

export const getNavigationPage = () => {
  return sessionStorage.getItem("currentNavPage") || null;
};

export const getPage = () => {
  return sessionStorage.getItem("currentPage") || null;
};

export const getValueSearchFilter = () => {
  return sessionStorage.getItem("valueSearchFilter" || null);
};

export const getAvaliblePlatforms = (value) => {
  const platformStr = sessionStorage.getItem("platforms");
  if (platformStr) return JSON.parse(platformStr);
  else return null;
};

export const getClasificacion = (dimension) => {
  switch (dimension) {
    case "A": case "S": case "A (EXT.) - (WIDTH X HEIGTH X LENGTH) 50 X 48 X 16 CM":
      return "P";
    case "B": case "M": case "B (EXT.) - (WIDTH X HEIGTH X LENGTH) 50 X 48 X 33 CM":
      return "M";
    case "C": case "L": case "C (EXT.) - (WIDTH X HEIGTH X LENGTH) 50 X 48 X 50 CM":
      return "G";
    case "D": case "XL":
      return "XG";
    default:
      break;
  }
};

//  ------- > SETTERS
export const setAvaliblePlatforms = (value) => {
  sessionStorage.setItem("platforms", JSON.stringify(value));
};

export const removeUserSession = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
};

export const setUserSession = (token, user) => {
  sessionStorage.setItem("token", token);
  sessionStorage.setItem("user", JSON.stringify(user));
};


export const setClientDomain = (location) => {
  sessionStorage.setItem("clDomain", location);
  
  const config = {
    prod: {
      apDomain: "https://api-cotel.myboxit.com/v1",
    },
    dev: {
      apDomain: "https://dev-api-cotel.myboxit.com/v1",
    },
    localhost: {
      apDomain: "http://localhost:5000/v1",
    }
};

  if (location === "cotel.myboxit.com"){
    sessionStorage.setItem("apDomain", config.prod.apDomain);
  }else if(location === "dev-cotel.myboxit.com"){
    sessionStorage.setItem("apDomain", config.dev.apDomain);
  }else{
    sessionStorage.setItem("apDomain", config.localhost.apDomain);
  }

};

export const setNavigationPage = (value) => {
  sessionStorage.setItem("currentNavPage", value);
};

export const setPage = (value) => {
  sessionStorage.setItem("currentPage", value);
};

export const setValueSearchFilter = (value) => {
  sessionStorage.setItem("valueSearchFilter", value);
};

//  ------- > OTHER METHODS
export const round = (value, decimals) => {
  return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
};

export const checkConnectionStatus = () => navigator.onLine;
/*
export const exportToPDF = (nombreReporte, filename, reportCol, reportRows, titleFile) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "px",
    format: "a4",
  });

  let logoBoxit = new Image();
  logoBoxit.src = "/img/logo-boxit.png";
  doc.addImage(logoBoxit, "PNG", 340, 20, 80, 30);
  const fecha = new Date();

  doc.setFont("Helvetica", "bold");
  doc.setFontSize(25);
  doc.text("Correos Panamá", 40, 40);
  doc.setFont("Helvetica", "normal");
  doc.setFontSize(10);
  doc.text(
    `${fecha.getDate() < 10 ? `0${fecha.getDate()}` : fecha.getDate()}/${
      fecha.getMonth() + 1 < 10
        ? `0${fecha.getMonth() + 1}`
        : fecha.getMonth() + 1
    }/${fecha.getFullYear()} ${
      fecha.getHours() <= 12 ? fecha.getHours() : fecha.getHours() - 12
    }:${
      fecha.getMinutes() < 10 ? `0${fecha.getMinutes()}` : fecha.getMinutes()
    } ${fecha.getHours() < 12 ? "AM" : "PM"}`,
    40,
    50
  );
  doc.text(
    `Elaborado por: ${getUser().NombreSimple} ${getUser().ApellidoSimple}`,
    40,
    65
  );
  doc.text(`Reporte: ${nombreReporte}`, 40, 75);

  // Centrado del título
  doc.setFont("Helvetica", "bold");
  doc.setFontSize(13);

  const pageWidth = doc.internal.pageSize.getWidth();  // Obtener el ancho de la página
  const titleWidth = doc.getTextWidth(titleFile);      // Obtener el ancho del texto
  const xPos = (pageWidth - titleWidth) / 2;           // Calcular la posición X para centrar el texto

  doc.text(titleFile, xPos, 100);  // Utiliza xPos para centrar el texto horizontalmente

  doc.autoTable({
    startY: 110,
    styles: { fontSize: 8 },
    columns: reportCol,
    body: reportRows,
  });

  doc.save(
    `${filename} ${
      fecha.getDate() < 10 ? `0${fecha.getDate()}` : fecha.getDate()
    }-${
      fecha.getMonth() + 1 < 10
        ? `0${fecha.getMonth() + 1}`
        : fecha.getMonth() + 1
    }-${fecha.getFullYear()}`
  );
};
*/
export const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const scrollTo = (value) =>
  document.getElementById("mainLayout").scrollTo({
    top: value,
    behavior: "smooth",
  });

export const copyToClipboard = (value) => copy(value);

export const translate = (key) => {
  const lang = window.navigator.language?.split("-")[0];
  // let langStorage = localStorage.getItem("language"); // Comentar esta línea temporalmente
  let langStorage = "es"; // Descomentar esta línea temporalmente
  let language = null;

  if (langStorage == null) {
    localStorage.setItem("language", lang);
    language = localStorage.getItem("language");
  } else {
    language = langStorage;
  }

  switch (language) {
    case "es":
      return es[key];
    case "pt":
      return pt[key];
    default:
      return en[key];
  }
};


export const getFormatDate = (date) => {
  const year = date.substring(4, 0);
  let month = date.substring(7, 5);
  let day = date.substring(10, 8);
  return `${day} ${getNameMonth(month)} ${year}`;
};

export const getFormatDateInput = (date) => {
  return date ? date.split('T')[0] : "" ;
}

export const getNameGender = (gender) => {
  switch (gender) {
    case "M":
      return translate("global.female")
    case "H":
      return translate("global.male")
    default:
      break;
}

}

export const getFormatDateHour = (date) => {

  // Crear un objeto Date a partir de la cadena de fecha
  const fecha = new Date(date);

  // Obtener la hora y los minutos
  const hora = fecha.toLocaleTimeString("es-ES", {
    hour: "2-digit",
    hour12: false,
  });
  const minutos = fecha.getMinutes();

  return `Hora: ${hora}, Minutos: ${minutos}`;
};

export const getNameMonth = (month) => {
  const monthFormat = Number(month);

  const monthMap = {
    1: "common.full_months.january",
    2: "common.full_months.february",
    3: "common.full_months.march",
    4: "common.full_months.april",
    5: "common.full_months.may",
    6: "common.full_months.june",
    7: "common.full_months.july",
    8: "common.full_months.august",
    9: "common.full_months.september",
    10: "common.full_months.october",
    11: "common.full_months.november",
    12: "common.full_months.december",
  };

  const monthName = monthMap[monthFormat] || "Invalid Month";
  return translate(monthName);
};

export const generateResponse = (result) => {
  const codeToMessageMap = {
    200: {key : "login.activate.USER_WAS_ACTIVATED_SUCCESSFULLY", icon: true},
    404: {key : "login.activate.USER_NOT_FOUND", icon: false},
    400: {key : "login.activate.USER_IS_ALREADY_ACTIVE", icon: true},
    401: {key : "login.activate.UNAUTHORIZED_USER", icon: false},
    500: {key : "login.forgotpwd.validate.errorServer", icon: false},
  };

  const code = result.code || 500;
  const messageKey = codeToMessageMap[code].key;
  const iconValue = codeToMessageMap[code].icon;

  return {
    code: code,
    message: translate(messageKey) || result.message,
    icon: iconValue
  };
};

export const formatDatePicker = (date, type) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return type ? `${day}/${month}/${year}` : `${year}-${month}-${day}`;
};

export const generateExcelAccounting = (data) => {
  const headers = Object.keys(data[0]);
  const dataArray = data.map((item) => Object.values(item));
  dataArray.unshift(headers);

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(dataArray);
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, "Accounting.xlsx");
};

export const generateExcelFile = (data, name) => {
  const headers = Object.keys(data[0]);
  const dataArray = data.map((item) => Object.values(item));
  dataArray.unshift(headers);

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(dataArray);
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, `${name}.xlsx`);
};

export const formatNumDecimal = (num) => {
  return num.toFixed(2);
};

export const parseExcel = (file) => {
  const columnKeys = [];
  file.forEach((row) => {
    Object.keys(row).forEach((key) => {
      if (!columnKeys.includes(key?.toUpperCase()))
        columnKeys.push(key?.toUpperCase());
    });
  });

  const rows = file.map((row) =>
    columnKeys.map((key) =>
      row[key] !== undefined && row[key] !== null ? row[key] : "-"
    )
  );
  const cols = columnKeys.map((name, index) => ({
    name: String.fromCharCode(65 + index),
    key: index,
  }));

  const result = {
    rows: [columnKeys, ...rows],
    cols: cols,
  };

  return result;
};

export const getDateSeparate = (inputDate) => {
  const dateParts = inputDate.split("-");

  const result = {
    day: dateParts[2],
    month: dateParts[1],
    year: dateParts[0],
  };

  return result;
};
export function verifyHideCountry() {
  var country = localStorage.getItem('country');

  if (country && (country.toLowerCase() === 'br' || country.toLowerCase() === 'us')) {
    return false;
  } else {
    return true;
  }
}

export function verifyHideCountryItems(countryToHide) {
  var country = localStorage.getItem('country');

  if (country && Array.isArray(countryToHide) && countryToHide.map(c => c.toLowerCase()).includes(country.toLowerCase())) {
    return false; 
  } else {
    return true;
  }
}

export const todayDate = new Date();
export const firstDayOfMonth = new Date(todayDate.getFullYear(), todayDate.getMonth(), 1);
const lastDayOfMonth = new Date(todayDate.getFullYear(), todayDate.getMonth() + 1, 0);

export const formatDate = (date) => {
  return date.toISOString().split('T')[0];
};

export const getTimeFormat = (dateString) => {
  
  const date = new Date(dateString);

  // Get hours, minutes, and seconds
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let seconds = date.getSeconds();

  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  seconds = seconds < 10 ? '0' + seconds : seconds;

  const result = hours + ':' + minutes + ':' + seconds;

  return result;
}



export const findActionsByPath = (data, path) => {

  const searchOptions = (options) => {
    for (const option of options) {
        if (option.path === path && option.actions) {
            return option.actions;
        } else if (option.subNav && option.subNav.length > 0) {
            const actions = searchOptions(option.subNav);
            if (actions.length > 0) {
                return actions;
            }
        }
    }
    return [];
}

return searchOptions(data.options);
  }


export const formatCurrency = (amount) => {
    if (isNaN(amount)) {
      return "B/. 0.00"; // Devuelve un valor predeterminado si no es un número
    }
  
    return `B/. ${parseFloat(amount)
      .toFixed(2) // Formatea con dos decimales
      .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`; // Agrega comas como separadores de miles
  };

export const getCashStatus = (statusId) => {
    return cashStatusConfig[statusId] || null;
  };

export const getRemittanceType = (idTipoRemesa) => {
    switch (idTipoRemesa) {
      case 1:
        return 'Postal';
      case 2:
        return 'Telegráfica';
      default:
        return ' ';
    }
  };

export const getRolName = (rol) => {
    switch (rol) {
      case 1:
        return 'Agente de estafeta';
      case 2:
        return 'Recaudador de estafeta';
      case 3:
        return 'Jefe/Supervisor de estafeta';
      case 4:
        return 'Recaudador provincial';
      case 5:
        return 'Contador provincial';
      case 6:
        return 'Administrador Provincial';
      case 7:
        return 'Consultante';
      case 8:
        return 'Soporte Técnico';
      case 9:
        return 'Super Admin';
      default:
        return ' ';
    }
  }

  export const getProvinceName = (province) => {
    switch (province) {
      case 1:
        return 'Bocas del Toro';
      case 2:
        return 'Coclé';
      case 3:
        return 'Colón';
      case 4:
        return 'Chiriquí';
      case 5:
        return 'Darién';
      case 6:
        return 'Herrera';
      case 7:
        return 'Los Santos';
      case 8:
        return 'Panamá';
      case 9:
        return 'Veraguas';
      case 10:
        return 'Panamá Oeste';
      default:
        return ' ';
    }
  }

export const getStatusRequests = (statusId) => {
    switch (statusId) {
      case 1:
        return 'Pendiente';
      case 2:
        return 'Aprobada';
      case 3:
        return 'Rechazada';
      case 4:
        return 'Cancelada';
      default:
        return ' ';
    }
  };

export const getActionName = (actionId) => {
    switch (actionId) {
      case 3: 
      return 'Acreditar';
      case 4:
      return 'Debitar';
      case 5:
      return 'Anular';
      case 6:
      return 'Depositar';
      default:
      return ' ';
    }
  };

export const getTypeRequestName = (typeId) => {
    switch (typeId) {
      case 1:
      return 'Movimiento Estafeta';
      case 2:
      return 'Movimiento Caja';
      case 3: 
      return 'Depósito';
      case 4:
      return 'Movimiento Caja - Informe Diario';
      default:
      return ' ';
    }
  };
      

export const provincesPrefix = () => {
  return [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
    { value: "13", label: "13" },
  ];
};

export const idFormats = () => {
  return [
    { value: "cedula", label: "Cédula", placeholder: "XXXX-XXXX" }, 
    { value: "cedula-E", label: "Cédula E", placeholder: "XXXX-XXXX o XXXXXX" },
    { value: "cedula-PE", label: "Cédula PE", placeholder: "XXXX-XXXX o X-XXXXX" }, 
    { value: "cedula-N", label: "Cédula N", placeholder: "XXXX-XXXX o X-XXXXX" },
    { value: "cedula-AV", label: "Cédula AV", placeholder: "AV-XXXX-XXXX" },
    { value: "cedula-PI", label: "Cédula PI", placeholder: "PI-XXXX-XXXX" },
    { value: "pasaporte", label: "Pasaporte", placeholder: "Ingrese pasaporte" }
  ];
};

export const updateFullId = (newPrefix, newNumber, newType) => {
  const [_, docType = ''] = (newType || '').split('-');
  let formattedId = '';

  if (newType === 'pasaporte') {
    formattedId = newNumber;
  } else if (docType === 'AV') {
    formattedId = `${newPrefix}${newNumber}`;
  } else if (docType === 'PI') {
    formattedId = `${newPrefix}${newNumber}`;
  } else if (docType) {
    formattedId = `${docType}-${newPrefix}-${newNumber}`;
  } else {
    formattedId = `${newPrefix}-${newNumber}`;
  }

  return formattedId;
};

export const normalizeIdNumber = (value, idType) => {

    const cleanedValue = idType === "pasaporte" 
      ? value.trim() 
      : value.replace(/[^A-Z0-9]/gi, "").toUpperCase();

    const normalizeCedula = (val) => {
        let cleanVal = val.replace(/[^0-9]/g, '');
        cleanVal = cleanVal.slice(-10);
        if (cleanVal.length < 6) return '';
        if (cleanVal.length === 10) {return cleanVal.replace(/^(\d{4})(\d{6})$/, '$1-$2'); }
        if (cleanVal.length === 8) {return cleanVal.replace(/^(\d{4})(\d{4})$/, '$1-$2'); }
        return cleanVal; 
    };

    const normalizeCedulaWithPrefix = (val, prefix) => {
        const numbersOnly = val.replace(/\D/g, '').slice(0, 9); 
        let formatted = `${prefix}-`;
        if (numbersOnly.length <= 3) {formatted += numbersOnly;} 
        else if (numbersOnly.length <= 7) {formatted += `${numbersOnly.slice(0, 3)}-${numbersOnly.slice(3)}`;} 
        else if (numbersOnly.length <= 8) {formatted += `${numbersOnly.slice(0, 4)}-${numbersOnly.slice(4)}`;}
        else {formatted += `${numbersOnly.slice(0, 4)}-${numbersOnly.slice(4)}`;}
        return formatted;
    };

    const handlers = {
        cedula: (val) => {
            let cleanVal = val.replace(/-/g, '').slice(0, 9);
            if (cleanVal && !/^\d+$/.test(cleanVal)) return '';
            if (cleanVal.length <= 3) {
                return cleanVal;
            } else if (cleanVal.length <= 7) {
                return cleanVal.replace(/^(\d{3})(\d{0,4})/, '$1-$2');
            } else {
                return cleanVal.replace(/^(\d{4})(\d{0,4})/, '$1-$2');
            }
        },
        "cedula-E": normalizeCedula,
        "cedula-PE": normalizeCedula,
        "cedula-N": normalizeCedula,
        "cedula-AV": (val) => normalizeCedulaWithPrefix(val, "AV"),
        "cedula-PI": (val) => normalizeCedulaWithPrefix(val, "PI"),    
        pasaporte: (val) => val.trim()
    };

    return handlers[idType]?.(cleanedValue) || cleanedValue;
};

export const validateIdFormat = (value, idType) => {
  if (!value || !idType) {
    return false;
  }

  const cleanedValue = idType === "pasaporte" 
    ? value.trim() 
    : value.replace(/[^A-Z0-9-]/gi, "").toUpperCase();

  const validators = {
    "cedula": (val) => {
      const regex = /^([1-9]|1[0-3])-\d{3}-\d{4}$|^([1-9]|1[0-3])-\d{4}-\d{4}$/;
      return regex.test(val);
    },
    "cedula-E": (val) => {
      const regex = /^E-([1-9]|1[0-3])(-\d{6}|-\d{3}-\d{4}|-\d{4}-\d{4}|-\d{4}-\d{6})$/;
      return regex.test(val);
    },
    "cedula-PE": (val) => {
      const regex = /^PE-\d+(-\d+)+$/;
      return regex.test(val);
    },
    "cedula-N": (val) => {
      const regex = /^N-([1-9]|1[0-3])(-\d{6}|-\d{3}-\d{4}|-\d{4}-\d{4}|-\d{4}-\d{6})$/;
      return regex.test(val);
    },
    "cedula-AV": (val) => {
      const regex = /^([1-9]|1[0-3])AV-\d{3,4}-\d{4,5}$/;
      return regex.test(val);
    },
    "cedula-PI": (val) => {
      const regex = /^([1-9]|1[0-3])PI-\d{3,4}-\d{4,5}$/;
      return regex.test(val);
    },
    pasaporte: (val) => {
      return val.trim().length > 0;
    }
  };

  return validators[idType]?.(cleanedValue) || false;
};

export const sqlDateFormat = (date, type, returnReadable, timezoneOffset = +5) => {
    const days = [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ];
    const months = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ];
  
    // Crear una fecha ajustada con el desplazamiento de zona horaria
    const sqlDate = new Date(date);
    sqlDate.setHours(sqlDate.getHours() + timezoneOffset);
  
    const day = days[sqlDate.getDay()];
    const dayNumber = sqlDate.getDate();
    const month = months[sqlDate.getMonth()];
    const monthNumber = sqlDate.getMonth() + 1;
    const year = sqlDate.getFullYear();
    const hours = sqlDate.getHours() % 12 || 12; // Formato 12 horas
    const minutes = sqlDate.getMinutes().toString().padStart(2, "0");
    const ampm = sqlDate.getHours() >= 12 ? "pm" : "am";
  
    if (type === "date") {
      return `${dayNumber}/${monthNumber}/${year}`;
    }

    if (type === "hour") {
      return `${hours}:${minutes}${ampm}`;
    }
    
    if (returnReadable) {
      return `${day} ${dayNumber} de ${month} ${year} - ${hours}:${minutes}${ampm}`;
    }
  
    if (type) {
      return `${sqlDate.getFullYear()}-${(sqlDate.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${sqlDate
        .getDate()
        .toString()
        .padStart(2, "0")} ${sqlDate
        .getHours()
        .toString()
        .padStart(2, "0")}:${sqlDate
        .getMinutes()
        .toString()
        .padStart(2, "0")}:${sqlDate.getSeconds().toString().padStart(2, "0")}`;
    }
  
    return sqlDate.toLocaleString("en-US").replace(",", "");
  };

export const printInvoice = async (remesa, copyNumber, deliver) => {
  
  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [80, 297]
  });

  const margin = 5;
  const contentWidth = 80 - 2 * margin;
  const centerX = 40; 
  const lineSpacing = 4; 
  let logo = new Image();
  const formattedDate = new Date().toLocaleString("es-PA", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
  
  // Validar y procesar InfoCOTEL de forma segura
  const infoCotel = {
    Info1: "Correos Panamá",
    Info2: "RUC: 123456789",
    Info3: "Dirección de la estafeta",
    Info4: "Información adicional"
  };

  if (remesa.InfoCOTEL && typeof remesa.InfoCOTEL === 'string') {
    const infoParts = remesa.InfoCOTEL.split(",");
    if (infoParts.length >= 4) {
      infoCotel.Info1 = infoParts[0]?.trim() || infoCotel.Info1;
      infoCotel.Info2 = infoParts[1]?.trim() || infoCotel.Info2;
      infoCotel.Info3 = infoParts[2]?.trim() || infoCotel.Info3;
      infoCotel.Info4 = infoParts[3]?.trim() || infoCotel.Info4;
    }
  }
    const isDelivered = remesa.IdEstatus === 2;
    const isReintegration = remesa.IdEstatus === 3;
    const isDeliveredExpiration = remesa.IdEstatus === 5;
    const isReintegrationExpiration = remesa.IdEstatus === 6;

    
    // Procesar métodos de pago de forma segura
    const processPaymentDetails = (paymentString) => {
        if (!paymentString || typeof paymentString !== 'string') return [];
        
        try {
            return paymentString.split(',').map((payment) => {
                const trimmedPayment = payment.trim();
                if (!trimmedPayment) return null;
                
                const [type, amount] = trimmedPayment.split(' ($');
                if (!type || !amount) return null;
                
                const cleanAmount = amount.replace(')', '').replace('$', '').trim();
                const parsedAmount = parseFloat(cleanAmount);
                
                if (isNaN(parsedAmount)) return null;
                
                return {
                    label: type.trim(),
                    amount: parsedAmount,
                };
            }).filter(payment => payment !== null);
        } catch (error) {
            console.error('Error procesando métodos de pago:', error);
            return [];
        }
    };
    const paymentDetails = processPaymentDetails(remesa.MetodosPago);

    // Calcular totales de forma segura
    const safeReduce = (array, key) => {
        if (!Array.isArray(array)) return 0;
        return array.reduce((acc, item) => {
            const value = item && typeof item === 'object' ? item[key] : 0;
            return acc + (isNaN(value) ? 0 : value);
        }, 0);
    };



    const totalPaid = safeReduce(paymentDetails, 'amount');
  
    
    // Validar montos de forma segura
    const safeNumber = (value) => {
        const num = parseFloat(value);
        return isNaN(num) ? 0 : num;
    };

    const round2 = (value) => Math.round((safeNumber(value) + Number.EPSILON) * 100) / 100;

    const totalRemittance = round2(remesa.MontoTotal);

    const changeDelivered = Math.max(round2(totalPaid - totalRemittance), 0);

    // Función para obtener valores seguros de texto
    const safeText = (value, defaultValue = 'N/A') => {
        if (value === null || value === undefined) return defaultValue;
        
        // Convertir a string si es número u otro tipo
        const stringValue = String(value);
        const trimmedValue = stringValue.trim();
        
        return trimmedValue || defaultValue;
    };

    const caja = safeText(
        !deliver ? remesa.CajaCreacion : (isReintegration || isDeliveredExpiration || isReintegrationExpiration ? remesa.CajaCreacion : remesa.CajaEntrega),
        'Caja no especificada'
    );
    const estafetaHeader = safeText(
        !deliver ? remesa.NombreSucursalOrigen : (isReintegration || isReintegrationExpiration ? remesa.NombreSucursalOrigen : remesa.NombreSucursalDestino),
        'Estafeta no especificada'
    );
    const estafetaGiros = safeText(
        isReintegration || isReintegrationExpiration ? remesa.NombreSucursalOrigen : remesa.NombreSucursalDestino,
        'Estafeta no especificada'
    ); 

    // Header
    try {
        logo.src = "../../img/logo-correos.png";
        pdf.addImage(logo, "PNG", centerX - 15, margin, 30, 12);
    } catch (error) {
        console.warn('No se pudo cargar el logo, continuando sin imagen:', error);
        // Continuar sin logo si hay error
    } 
    pdf.setFontSize(9).setFont("helvetica", "bold");
    pdf.text(infoCotel.Info1, centerX, 23, { align: "center" });
    pdf.setFont("helvetica", "normal");
    pdf.text("RUC: "+infoCotel.Info2, centerX, 27, { align: "center" });
    if (!deliver) {
    pdf.text(`FECHA: ${formattedDate}`, centerX, 31, { align: "center" });
    }
    // Detalles
    pdf.setFontSize(8.5);
    let y = 35; 
    pdf.text(`CAJA: ${caja}`, margin, y);
    pdf.text(`DETALLES DEL GIRO: #${safeText(remesa.IdRemesa, 'N/A')}`, margin, (y += lineSpacing));
    pdf.text(`ESTAFETA: ${estafetaHeader}`, margin, (y += lineSpacing));
    pdf.text(infoCotel.Info3, margin, (y += lineSpacing));

    // Detalles Remitente
    if (!deliver) {
    pdf.setFontSize(8); 
    pdf.text("--------------DATOS DEL CLIENTE/REMITENTE--------------", centerX, (y += lineSpacing), { align: "center" });
    pdf.setFontSize(8);
    pdf.setFont("helvetica", "normal");
    pdf.text(`NOMBRE: ${safeText(remesa.NombreCompletoRemitente, 'No especificado')}`, margin, (y += lineSpacing));
    pdf.text(`CÉDULA: ${safeText(remesa.IdRemitente, 'No especificado')}`, margin, (y += lineSpacing));
    }
    // Tabla

    pdf.setFontSize(8);
    if (!deliver) {  
        y += 3;     
        pdf.text("-----------------------------DETALLE----------------------------------", centerX, y, { align: "center" });
    }
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(7);
    y += 4; 
    if (!deliver) {
        pdf.text("CANT/BULTO", margin, y);
        pdf.text("DESCRIPCIÓN", margin + 25, y);
        pdf.text("IMPORTE", margin + 50, y);   
    y += 4; 
    }

    pdf.setFontSize(8);
    pdf.text("-----------------------------------------------------------------------------", centerX, y, { align: "center" });
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(7.5);

    // Contenido de la tabla
    y += 3;
    pdf.text("1)TRANSFERENCIA MONETARIA", margin, y);
    if (deliver) {
    pdf.text(`REMITENTE : ${safeText(remesa.NombreCompletoRemitente, 'No especificado')}`, margin, (y += lineSpacing));
    }
    pdf.text(`BENEFICIARIO:  ${safeText(remesa.NombreCompletoDestinatario, 'No especificado')}`, margin, (y += lineSpacing));
    if (!deliver) {
    pdf.text(`CÉDULA: ${safeText(remesa.IdDestinatario, 'No especificado')}`, margin, (y += lineSpacing)); 
    }
    if (remesa.IdTipoRemesa === 1) {
    pdf.text("GIROS POSTALES/", margin, (y += lineSpacing));
    } else {
    pdf.text("GIROS TELEGRAFICOS/", margin, (y += lineSpacing));
    }
    if (!deliver){
        pdf.text(`HACIA:`, margin, (y += lineSpacing));
        pdf.text(`${estafetaGiros}`, margin, (y += lineSpacing));
    } else {
        pdf.text(`PAGADO EN:`, margin, (y += lineSpacing));
        pdf.text(`${estafetaGiros}`, margin, (y += lineSpacing));
    }
  
    const montoToShow = [2, 3].includes(remesa.IdEstatus) ? remesa.MontoFinal : remesa.MontoEnviar;
    pdf.text(
      `B/.${safeNumber(montoToShow).toFixed(2)}`,
      margin + 50,
      y
    );
    if (!deliver) {
    pdf.text("COMISIÓN:", margin, (y += lineSpacing + 1));
    pdf.text(`B/.${safeNumber(remesa.MontoFee).toFixed(2)}`, margin + 50, y);

    pdf.text("SERVICIOS ADICIONALES:", margin, (y += lineSpacing + 1));
    pdf.text("+TRANSMISIÓN", margin, (y += lineSpacing));
    pdf.text(`B/.${safeNumber(remesa.MontoTransmision).toFixed(2)}`, margin + 50, y);
    pdf.line(margin, (y += 2), 80 - margin, y);
    } else {
        pdf.text("FECHA TRANSFERENCIA:", margin, (y += lineSpacing + 1));
        pdf.text(`${formattedDate}`, margin + 40, y);
    }
    // Total
    pdf.text("TOTAL", margin, (y += lineSpacing + 1));
    if (!deliver) {
    pdf.text(`B/.${safeNumber(remesa.MontoTotal).toFixed(2)}`, margin + 50, y);
    } else {
      pdf.text(`B/.${safeNumber(remesa.MontoFinal).toFixed(2)}`, margin + 50, y);
    }
    pdf.line(margin, (y += 2), 80 - margin, y);
    if (!deliver) {
    const paymentDetailsToShow = paymentDetails;
    paymentDetailsToShow.forEach((payment) => {
        pdf.text(payment.label, margin, (y += lineSpacing));
        pdf.text(`B/.${payment.amount.toFixed(2)}`, margin + 50, y);
    });

    // Cambio
    pdf.text("CAMBIO", margin, (y += lineSpacing));
    pdf.text(`B/.${changeDelivered.toFixed(2)}`, margin + 50, y);
    } 

    // Footer
    y += 4;
    if (!deliver) {
        if (copyNumber === 1) {
        pdf.text("----------------------------PIN DE RETIRO-----------------------------", centerX, y, { align: "center" });
        pdf.setFontSize(10);
        pdf.setFont("helvetica", "bold");
        pdf.text(`${safeText(remesa.Clave, 'PIN no disponible')}`, centerX, (y += lineSpacing), { align: "center" });
        } else {
        pdf.text("-----------------------COPIA DE OFICINISTA------------------------", centerX, y, { align: "center" });
        }
    } else {
        if (copyNumber === 1) {
            if (!isReintegration && !isReintegrationExpiration) {
                y += lineSpacing;
                pdf.text("FIRMA BENEFICIARIO: _____________________________", centerX, y, { align: "center" });
                y += lineSpacing;
                pdf.text(`${safeText(remesa.NombreCompletoDestinatario, 'No especificado')} - ${safeText(remesa.IdDestinatario, 'No especificado')}`, margin, y);
                y += lineSpacing;
                pdf.text("-----------------------COPIA DE OFICINISTA------------------------", centerX, y, { align: "center" });
                
            } else {
                y += lineSpacing;
                pdf.text("FIRMA REMITENTE: ____________________________", centerX, y, { align: "center" });
                y += lineSpacing;
                pdf.text(`${safeText(remesa.NombreCompletoRemitente, 'No especificado')} - ${safeText(remesa.IdRemitente, 'No especificado')}`, margin, y);
                y += lineSpacing;
                pdf.text("-----------------------COPIA DE OFICINISTA------------------------", centerX, y, { align: "center" });                
            }
        } else {
        y += lineSpacing;
        }
    }
    pdf.setFontSize(7);
    pdf.line(margin, (y += 4), 80 - margin, y);
    pdf.setFont("helvetica", "bold");
  
    pdf.text("DOCUMENTO NO FISCAL", centerX, (y += 4), { align: "center", maxWidth: contentWidth });
    y += lineSpacing; 
    pdf.setFontSize(7.5).setFont("helvetica", "normal");
    if (!deliver) {

    const warningText =  infoCotel.Info4;
    const splitWarningText = pdf.splitTextToSize(warningText, contentWidth);
    pdf.text(splitWarningText, centerX, (y += lineSpacing), { align: "center" });

    y += splitWarningText.length * (lineSpacing - 1);
    }
    pdf.text("TU CORREO SEGURO Y ECONÓMICO", centerX, y, { align: "center" });
    pdf.setFont("helvetica", "bold");
    pdf.text("¡GRACIAS POR SU PREFERENCIA!", centerX, (y += lineSpacing), { align: "center" });

    try {
        const pdfBlob = pdf.output("blob");
        return pdfBlob;
    } catch (error) {
        console.error('Error generando el PDF:', error);
        return null;
    }
};

  export const handleMessageElaborated = async (user) => {
    switch (user.roleId) {
        case 1:
            return `Agente de Estafeta ${user.CodigoEstafeta} ${user.NombreEstafeta}`;
        case 2:
            return `Recaudador de Estafeta ${user.CodigoEstafeta} ${user.NombreEstafeta}`;
        case 3:
            return `Jefe/Supervisor de Estafeta ${user.CodigoEstafeta} ${user.NombreEstafeta}`;
        case 4:
            return `Recaudador provincial de Estafeta ${user.CodigoEstafeta} ${user.NombreEstafeta}`;
        case 5:
            return `Contador provincial de Estafeta ${user.CodigoEstafeta} ${user.NombreEstafeta}`;
        case 6:
            return `Consultante ${user.CodigoEstafeta} ${user.NombreEstafeta}`;
        case 7:
            return `Administrador de Sistema ${user.CodigoEstafeta} ${user.NombreEstafeta}`;
        case 8:
            return `Super administrador ${user.CodigoEstafeta} ${user.NombreEstafeta}`;
        default:
            return `Usuario de Estafeta ${user.CodigoEstafeta} ${user.NombreEstafeta}`;
    }
};

  export const exportCustomReportPDF = async (data, columns, filename, nameReport, roleId) => {
    await exportToPDF({
      data,
      columns,
      filename,
      nameReport,
      roleId
    });
  };

  export const exportCustomReportExcel = async (data, columns, filename, nameReport, roleId) => {
    await exportToExcel({
      data,
      columns,
      filename,
      nameReport,
      roleId
    });
  };

  export const exportMultipleTablesExcel = async (tables, filename, roleId) => {
    await exportMultipleTablesToExcel({
      tables,
      filename,
      roleId
    });
  };

  export const exportMultipleTablesPDF = async (tables, filename, roleId) => {
    await exportMultipleTablesToPDF({
      tables,
      filename,
      roleId
    });
  };
